import { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import { clienteSchema } from "../../../shared/util/schemas";
import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";
import DriveFolderUploadOutlined from "@mui/icons-material/DriveFolderUploadOutlined";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import { AuthContext } from "../../../shared/context/auth-context";
import { ClinicaContext } from "../../../shared/context/clinica-context";

import toast from "react-hot-toast";
//Mui icons
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PageviewIcon from "@mui/icons-material/Pageview";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

import "../../../style/formError.scss";
import "../new/NewCliente.scss";
import ModalListaClientesFinancas from "../components/modalListaClientesFinancas/ModalListaClientesFinancas";

import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import codigoPaises from "../components/codigoPaises";

import { fixSpaces } from "../../../shared/util/helperFunctions";
import { compressImage } from "../../../shared/util/compressImage";

import { useLoading } from "../../../shared/context/LoadingContext";

import BusinessIcon from "@mui/icons-material/Business";

import {
  ModalDuplicidadeAbsoluta,
  ModalDuplicidadeRelativa,
} from "../components/modaisVerificacaoDuplicidade/ModaisVerificacaoDuplicidade";

function Edit() {
  const { startLoading, stopLoading } = useLoading();
  const [file, setFile] = useState("");
  const [initialImage, setInitialImage] = useState("");
  const [formikInitialValues, setFormikInitialValues] = useState(null);

  const { sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const clienteId = useParams().clienteId;
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState([]);

  const [nome, setNome] = useState("");
  const [nomeFiscal, setNomeFiscal] = useState("");
  const [nif, setNif] = useState("");
  const [identificacao, setIdentificacao] = useState("");
  const [pais, setPais] = useState({ nome: "CABO VERDE", codigo: "CV" });

  const [empresasParceiras, setEmpresasParceiras] = useState([]);
  const [empresaParceira, setEmpresaParceira] = useState("");

  // Estados para os modais de duplicidade
  const [modalDuplicidadeAbsoluta, setModalDuplicidadeAbsoluta] =
    useState(false);
  const [modalDuplicidadeRelativa, setModalDuplicidadeRelativa] =
    useState(false);
  const [clientesDuplicados, setClientesDuplicados] = useState([]);
  const [dadosFormParaSubmit, setDadosFormParaSubmit] = useState(null);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleChooseCliente = (cliente) => {
    setOpenModal(false);
    setNomeFiscal(cliente.Name);
    setNome(cliente.Name);

    setNif(cliente.TaxId);
    setIdentificacao(cliente.BI);
  };

  useEffect(() => {
    const fetchCliente = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/${clienteId}?clinicaId=${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        setFormikInitialValues({
          genero: responseData.cliente.genero ?? "",
          email: responseData.cliente.email ?? "",
          contacto2: responseData.cliente.contacto2 ?? "",
          contacto: responseData.cliente.contacto,
          sms: responseData.cliente.sms ? responseData.cliente.sms : false,
          com_email: responseData.cliente.com_email
            ? responseData.cliente.com_email
            : false,
          com_whatsapp: responseData.cliente.com_whatsapp
            ? responseData.cliente.com_whatsapp
            : false,
          observacao: responseData.cliente.observacao ?? "",
          endereco: responseData.cliente.endereco ?? "",
          responsavel: responseData.cliente.responsavel ?? "",
          nr_beneficiario: responseData.cliente.nr_beneficiario ?? "",
          profissao: responseData.cliente.profissao ?? "",
          foto: responseData.cliente.foto,
          data_nasc: moment(responseData.cliente.data_nasc, "DD-MM-YYYY"),
        });

        if (responseData.cliente.pais) setPais(responseData.cliente.pais);

        setIdentificacao(
          responseData.cliente.identificacao
            ? responseData.cliente.identificacao
            : "",
        );
        setNif(responseData.cliente.nif ? responseData.cliente.nif : "");
        setNomeFiscal(responseData.cliente.nomeFiscal || "");
        setNome(responseData.cliente.nome || "");
        if (responseData.cliente.foto) {
          setInitialImage(
            `${process.env.REACT_APP_BACKEND_LINK}/${responseData.cliente.foto}`,
          );
        } else {
          setInitialImage("/images/no-image.jpg");
        }

        if (responseData.cliente.empresaParceira) {
          setEmpresaParceira(
            responseData.cliente.empresaParceira._id ||
              responseData.cliente.empresaParceira,
          );
        }
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchCliente();
  }, [sendRequest, clienteId, auth.token]);

  // DEPOIS - adicionar após o useEffect do fetchCliente
  useEffect(() => {
    const fetchEmpresasParceiras = async () => {
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/empresasparceiras/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        );
        setEmpresasParceiras(response.empresasParceiras || []);
      } catch (err) {
        console.error("Erro ao buscar empresas parceiras:", err);
      }
    };
    fetchEmpresasParceiras();
  }, [clinica.clinica._id, auth.token, sendRequest]);

  // Função para verificar duplicidade
  const verificarDuplicidade = async (dadosForm) => {
    try {
      const formData2 = new FormData();
      formData2.append("nome", dadosForm.nomeProcessado);
      formData2.append("nomeFiscal", dadosForm.nomeFiscalProcessado);
      formData2.append("contacto", dadosForm.contacto);
      formData2.append("nif", dadosForm.nif);
      formData2.append("clinica", dadosForm.clinica);
      formData2.append("clienteIdParaIgnorar", clienteId);

      const respostaDuplicidade = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/verificarduplicidade`,
        "POST",
        formData2,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      // Se não há duplicidade, pode continuar
      if (
        !respostaDuplicidade.duplicidade.absoluta &&
        !respostaDuplicidade.duplicidade.relativa
      ) {
        return true;
      }

      // Se há duplicidade absoluta, mostrar modal de erro
      if (respostaDuplicidade.duplicidade.absoluta) {
        setClientesDuplicados(
          respostaDuplicidade.duplicidade.clientesEncontrados,
        );
        setModalDuplicidadeAbsoluta(true);
        return false;
      }

      // Se há duplicidade relativa, mostrar modal de aviso
      if (respostaDuplicidade.duplicidade.relativa) {
        setClientesDuplicados(
          respostaDuplicidade.duplicidade.clientesEncontrados,
        );
        setDadosFormParaSubmit(dadosForm); // Guardar dados para uso posterior
        setModalDuplicidadeRelativa(true);
        return false;
      }

      return true;
    } catch (err) {
      console.error("Erro na verificação de duplicidade:", err);
      return true; // Em caso de erro, permitir continuar
    }
  };

  // Função para submeter o formulário (extraída da lógica original)
  const submeterFormulario = async (dadosForm) => {
    try {
      const formData = new FormData();

      formData.append("nomeFiscal", dadosForm.nomeFiscalProcessado);
      formData.append("nome", dadosForm.nomeProcessado);
      formData.append("genero", dadosForm.genero);
      formData.append("data_nasc", dadosForm.dataNascimento);
      formData.append("email", dadosForm.email);
      formData.append("contacto2", dadosForm.contacto2);
      formData.append("contacto", dadosForm.contacto);
      formData.append("pais", dadosForm.pais);
      formData.append("sms", dadosForm.sms);
      formData.append("com_email", dadosForm.com_email);
      formData.append("com_whatsapp", dadosForm.com_whatsapp);
      formData.append("observacao", dadosForm.observacao);

      if (dadosForm.foto) {
        formData.append("foto", dadosForm.foto);
      }

      formData.append("endereco", dadosForm.endereco);
      formData.append("responsavel", dadosForm.responsavel);
      formData.append("nif", dadosForm.nif);
      formData.append("identificacao", dadosForm.identificacao);
      formData.append("nr_beneficiario", dadosForm.nr_beneficiario);
      formData.append("profissao", dadosForm.profissao || "");
      formData.append("ativo", dadosForm.ativo);
      formData.append("atualizadoPor", dadosForm.atualizadoPor);

      if (dadosForm.empresaParceira) {
        formData.append("empresaParceira", dadosForm.empresaParceira);
      }

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/${clienteId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      toast.success("Cliente atualizado com sucesso!");
      navigate(`/clientes/${clienteId}`);
    } catch (err) {
      console.error("Erro ao atualizar cliente:", err);
    }
  };

  const onSubmit = async (values, actions) => {
    startLoading();
    try {
      if ((nomeFiscal?.trim() === "") === "" || !nomeFiscal) {
        toast.error("Introduza o nome do cliente antes de continuar");
      } else if (!pais || pais === "") {
        toast.error("Introduza o país do cliente antes de continuar");
      } else if (!nif || nif === "") {
        toast.error("Introduza o NIF do cliente antes de continuar");
      } else {
        // normalizar os nomes
        const wordsNomeFiscal = nomeFiscal.toLowerCase().split(" ");
        const wordsNome = nome.toLowerCase().split(" ");
        // Uppercase the first letter of each word
        const capitalizedWordsNomeFiscal = wordsNomeFiscal.map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1),
        );
        const capitalizedWordsNome = wordsNome.map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1),
        );
        const titledNameFiscal = fixSpaces(
          capitalizedWordsNomeFiscal.join(" "),
        );
        const titledName = fixSpaces(capitalizedWordsNome.join(" "));

        // Preparar foto se existir
        let fotoProcessada = null;
        if (file) {
          const fileExtension = file.name.split(".").pop();
          fotoProcessada = new File(
            [file],
            `${clinica.clinica._id}-${clienteId}.${fileExtension}`,
            { type: file.type },
          );
        }

        // Preparar dados para verificação e submissão
        const dadosForm = {
          nomeFiscalProcessado: titledNameFiscal,
          nomeProcessado: nome ? titledName : titledNameFiscal,
          genero: values.genero,
          dataNascimento: moment(values.data_nasc).format("DD-MM-YYYY"),
          email: fixSpaces(values.email),
          contacto2: fixSpaces(values.contacto2),
          contacto: values.contacto,
          pais: JSON.stringify(pais),
          sms: values.sms,
          com_email: values.com_email,
          com_whatsapp: values.com_whatsapp,
          observacao: values.observacao,
          foto: fotoProcessada,
          endereco: fixSpaces(values.endereco),
          responsavel: fixSpaces(values.responsavel),
          nif: nif,
          identificacao: identificacao,
          nr_beneficiario: values.nr_beneficiario,
          profissao: values.profissao,
          ativo: true,
          atualizadoPor: auth.userId,
          clinica: clinica.clinica._id,
          empresaParceira: empresaParceira || null,
        };

        // Verificar se houve mudanças que requerem verificação de duplicidade
        let precisaVerificarDuplicidade = false;
        if (formikInitialValues) {
          if (
            titledName.toLowerCase() !== nome.toLowerCase() ||
            fixSpaces(values.contacto) !==
              fixSpaces(formikInitialValues.contacto)
          ) {
            precisaVerificarDuplicidade = true;
          }
        }

        let podesContinuar = true;
        if (precisaVerificarDuplicidade) {
          // Verificar duplicidade
          podesContinuar = await verificarDuplicidade(dadosForm);

          if (!podesContinuar) {
            // Modal será aberto pela função verificarDuplicidade
            return;
          }
        }

        // Se chegou aqui, pode submeter
        await submeterFormulario(dadosForm);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  // Função para continuar após aviso de duplicidade relativa
  const continuarApesAviso = async () => {
    setModalDuplicidadeRelativa(false);
    if (dadosFormParaSubmit) {
      await submeterFormulario(dadosFormParaSubmit);
      setDadosFormParaSubmit(null);
    }
    stopLoading();
  };

  // Função para cancelar após aviso de duplicidade relativa
  const cancelarAposAviso = () => {
    setModalDuplicidadeRelativa(false);
    setDadosFormParaSubmit(null);
    stopLoading();
  };

  // Função para fechar modal de duplicidade absoluta
  const fecharModalAbsoluta = () => {
    setModalDuplicidadeAbsoluta(false);
    setClientesDuplicados([]);
    stopLoading();
  };

  const {
    values,
    touched,
    handleBlur,
    handleChange,
    errors,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
  } = useFormik({
    initialValues: formikInitialValues || {
      genero: "",
      email: "",
      contacto2: "",
      contacto: "",
      sms: false,
      com_email: false,
      com_whatsapp: false,
      observacao: "",
      endereco: "",
      responsavel: "",
      nr_beneficiario: "",
      profissao: "",
      data_nasc: null,
    },
    enableReinitialize: true,
    validationSchema: clienteSchema,
    onSubmit,
  });

  const findClientInfo = async (nif, nomeToCheck) => {
    if (pais.nome !== "CABO VERDE") {
      toast.error("Procura por nome ou nif só para Cabo Verde");
    } else {
      const formData = new FormData();
      nomeToCheck && formData.append("nome", nomeToCheck);
      nif && formData.append("nif", nif);

      try {
        startLoading();
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/documentoeletronico/nifbinome`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        stopLoading();

        if (!response?.payload) {
          toast.error("Nenhuma resposta da efatura");
        } else if (response?.payload?.length === 0) {
          toast.error("Nenhum cliente encontrado");
        } else if (response?.payload?.length === 1) {
          toast.success("Cliente encontrado");
          setNomeFiscal(response.payload[0].Name);
          setNome(response.payload[0].Name);
          if (!nome || nome.trim() === "") {
            setNome(response.payload[0].Name);
          }
          setNif(response.payload[0].TaxId);
          setIdentificacao(response.payload[0].BI);
        } else {
          setModalData(response.payload);
          setOpenModal(true);
        }
      } catch (error) {
        stopLoading();
        console.error(error);
      }
    }
  };
  // Custom option rendering function
  const renderOption = (props, option) => (
    <Box
      component="span"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "8px",
      }}
      {...props}
    >
      <Typography variant="subtitle1">{option.nome}</Typography>
      <Typography variant="body2" color="textSecondary">
        {option.codigo}
      </Typography>
    </Box>
  );

  return (
    <>
      <ModalListaClientesFinancas
        open={openModal}
        handleCloseModal={handleCloseModal}
        clientes={modalData}
        handleChooseCliente={handleChooseCliente}
      />

      <ModalDuplicidadeAbsoluta
        open={modalDuplicidadeAbsoluta}
        clientes={clientesDuplicados}
        onClose={fecharModalAbsoluta}
      />

      <ModalDuplicidadeRelativa
        open={modalDuplicidadeRelativa}
        clientes={clientesDuplicados}
        onClose={cancelarAposAviso}
        onContinuar={continuarApesAviso}
      />

      <div className="new-cliente">
        <Sidebar />
        <div className="newContainer">
          <Navbar
            title="Editar Cliente"
            icon={PersonOutlineOutlinedIcon}
            paths={[{ nome: "Clientes", link: `../..` }, { nome: "Editar" }]}
          />
          <div className="bottom caixa">
            <div className="bottom-left">
              <img src="/images/medico-ficha.png" alt="" />
            </div>
            <div className="bottom-right">
              <div className="imagePicker takes1-2">
                <div className="imagePickerContainer">
                  <img
                    src={file ? URL.createObjectURL(file) : initialImage}
                    alt=""
                  />
                  <label className="icon-file" htmlFor="file">
                    <DriveFolderUploadOutlined className="icon" />
                  </label>
                </div>

                <input
                  className="input"
                  type="file"
                  id="file"
                  onChange={async (e) => {
                    const original = e.target.files[0];
                    if (!original) return;
                    const compressed = await compressImage(original);
                    setFile(compressed);
                  }}
                  style={{ display: "none" }}
                />
              </div>

              <div className="takes2-5 form-input">
                <input
                  id="nomeFiscal"
                  name="nomeFiscal"
                  type="text"
                  placeholder="Nome Fiscal"
                  value={nomeFiscal}
                  onChange={(e) => setNomeFiscal(e.target.value)}
                  className={
                    errors.nomeFiscal && touched.nomeFiscal
                      ? "input-error input"
                      : "input"
                  }
                />
                <label className="label" htmlFor="nomeFiscal">
                  Nome Fiscal*
                </label>
                <PageviewIcon
                  className="icon-search-field"
                  onClick={findClientInfo.bind(null, null, nomeFiscal)}
                />
                {errors.nomeFiscal && touched.nomeFiscal ? (
                  <p className="error-message">{errors.nomeFiscal}</p>
                ) : null}
              </div>

              <div className="takes5-7">
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DesktopDatePicker
                    className="dataNascimento__cliente"
                    label="Data Nascimento*"
                    inputFormat="DD-MM-YYYY"
                    value={values.data_nasc || null}
                    onChange={(value) => {
                      setFieldValue("data_nasc", value);
                      setFieldTouched("data_nasc", true, false);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={touched.data_nasc && Boolean(errors.data_nasc)}
                        helperText={touched.data_nasc && errors.data_nasc}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>

              <div className="takes2-5 row2 form-input">
                <input
                  id="nome"
                  name="nome"
                  type="text"
                  placeholder="Nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  className={
                    errors.nome && touched.nome ? "input-error input" : "input"
                  }
                />
                <label className="label" htmlFor="nome">
                  Nome
                </label>
              </div>

              <div className="form-input takes5-7 row2">
                <select
                  id="genero"
                  name="genero"
                  value={values.genero}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.genero && touched.genero
                      ? "input-error input"
                      : "input"
                  }
                >
                  <option value="" disabled>
                    Género*
                  </option>
                  <option value="feminino">Feminino</option>
                  <option value="masculino">Masculino</option>
                  <option value="outro">Outro</option>
                </select>
                {errors.genero && touched.genero ? (
                  <p className="error-message">{errors.genero}</p>
                ) : null}
              </div>

              <div className="form-input takes1-3">
                <input
                  id="endereco"
                  name="endereco"
                  type="text"
                  placeholder="Mindelo"
                  value={values.endereco}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.endereco && touched.endereco
                      ? "input-error input"
                      : "input"
                  }
                />
                <label className="label" htmlFor="endereco">
                  Endereço*
                </label>
                {errors.endereco && touched.endereco ? (
                  <p className="error-message">{errors.endereco}</p>
                ) : null}
              </div>

              <div className="form-input takes3-5">
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.email && touched.email
                      ? "input-error input"
                      : "input"
                  }
                />
                <label className="label" htmlFor="email">
                  Email
                </label>
                {errors.email && touched.email ? (
                  <p className="error-message">{errors.email}</p>
                ) : null}
              </div>

              <div className="form-input takes5-7">
                <input
                  id="responsavel"
                  name="responsavel"
                  type="text"
                  placeholder="Joao Sousa"
                  value={values.responsavel}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.responsavel && touched.responsavel
                      ? "input-error input"
                      : "input"
                  }
                />
                <label className="label" htmlFor="responsavel">
                  Responsável
                </label>
                {errors.responsavel && touched.responsavel ? (
                  <p className="error-message">{errors.responsavel}</p>
                ) : null}
              </div>

              <div className="form-input takes1-3">
                <input
                  id="contacto"
                  name="contacto"
                  type="text"
                  placeholder="5999999"
                  value={values.contacto}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.contacto && touched.contacto
                      ? "input-error input"
                      : "input"
                  }
                />
                <label className="label" htmlFor="contacto">
                  Contacto*
                </label>
                {errors.contacto && touched.contacto ? (
                  <p className="error-message">{errors.contacto}</p>
                ) : null}
              </div>

              <div className="form-input takes3-5">
                <input
                  id="contacto2"
                  name="contacto2"
                  type="text"
                  placeholder="2313131"
                  value={values.contacto2}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.contacto2 && touched.contacto2
                      ? "input-error input"
                      : "input"
                  }
                />
                <label className="label" htmlFor="contacto2">
                  Contacto 2
                </label>
                {errors.contacto2 && touched.contacto2 ? (
                  <p className="error-message">{errors.contacto2}</p>
                ) : null}
              </div>

              <FormControl style={{ width: "100%" }} className="takes5-7">
                <Autocomplete
                  id="treatment-autocomplete"
                  value={pais}
                  onChange={(e, value) => setPais(value)}
                  options={codigoPaises}
                  getOptionLabel={(option) =>
                    `${option.nome} - ${option.codigo}`
                  }
                  renderOption={renderOption}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Pais"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </FormControl>

              <div className="form-input takes1-3">
                <input
                  id="identificacao"
                  name="identificacao"
                  type="text"
                  placeholder="1333333"
                  value={identificacao}
                  onChange={(e) => setIdentificacao(e.target.value)}
                  className={
                    errors.identificacao && touched.identificacao
                      ? "input-error input"
                      : "input"
                  }
                />
                <label className="label" htmlFor="identificacao">
                  BI / CNI
                </label>
                {errors.identificacao && touched.identificacao ? (
                  <p className="error-message">{errors.identificacao}</p>
                ) : null}
              </div>

              <div className="form-input takes3-5">
                <input
                  id="nif"
                  name="nif"
                  type="text"
                  placeholder="1333333"
                  value={nif}
                  onChange={(e) => setNif(e.target.value)}
                  className={
                    errors.nif && touched.nif ? "input-error input" : "input"
                  }
                />
                <label className="label" htmlFor="nif">
                  Nif
                </label>
                <PageviewIcon
                  className="icon-search-field"
                  onClick={findClientInfo.bind(null, nif, null)}
                />
                {errors.nif && touched.nif ? (
                  <p className="error-message">{errors.nif}</p>
                ) : null}
              </div>

              <div className="form-input takes5-7">
                <input
                  id="nr_beneficiario"
                  name="nr_beneficiario"
                  type="text"
                  placeholder="1333333"
                  value={values.nr_beneficiario}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.nr_beneficiario && touched.nr_beneficiario
                      ? "input-error input"
                      : "input"
                  }
                />
                <label className="label" htmlFor="nr_beneficiario">
                  Nr Beneficiário
                </label>
                {errors.nr_beneficiario && touched.nr_beneficiario ? (
                  <p className="error-message">{errors.nr_beneficiario}</p>
                ) : null}
              </div>

              <FormControl style={{ width: "100%" }} className="takes1-4">
                <Autocomplete
                  id="empresa-parceira"
                  value={
                    empresasParceiras.find(
                      (emp) => emp._id === empresaParceira,
                    ) || null
                  }
                  onChange={(e, value) =>
                    setEmpresaParceira(value ? value._id : "")
                  }
                  options={empresasParceiras}
                  getOptionLabel={(option) =>
                    `${option.nome} (${option.percentagemDesconto}%)`
                  }
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "8px",
                      }}
                      {...props}
                    >
                      <BusinessIcon
                        style={{ color: "#4caf50", fontSize: "20px" }}
                      />
                      <div>
                        <Typography variant="subtitle2">
                          {option.nome}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          Desconto: {option.percentagemDesconto}%
                        </Typography>
                      </div>
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Empresa Parceira"
                      variant="outlined"
                      helperText="Cliente receberá desconto nos orçamentos"
                    />
                  )}
                />
              </FormControl>

              {/* A Empresa Parceira ocupa as colunas 1-4; a profissão preenche
                  as 4-7 dessa mesma linha, que estavam vazias. Pô-la ao lado do
                  NIF colidia com a coluna dele e empurrava o Nr Beneficiário. */}
              <div className="form-input takes4-7">
                <input
                  id="profissao"
                  name="profissao"
                  type="text"
                  placeholder="Profissão"
                  value={values.profissao}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.profissao && touched.profissao
                      ? "input-error input"
                      : "input"
                  }
                />
                <label className="label" htmlFor="profissao">
                  Profissão
                </label>
                {errors.profissao && touched.profissao ? (
                  <p className="error-message">{errors.profissao}</p>
                ) : null}
              </div>

              <div className="formGroup takes1-4">
                <span className="comunicacao-consentimento">
                  O cliente consente receber notificações por:
                </span>
                <div className="comunicacao">
                  <label className="label">
                    Email?
                    <input
                      id="com_email"
                      name="com_email"
                      type="checkbox"
                      checked={values.com_email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.com_email && touched.com_email
                          ? "input-error input"
                          : "input"
                      }
                    />
                  </label>
                  <label className="label">
                    SMS?
                    <input
                      id="sms"
                      name="sms"
                      type="checkbox"
                      checked={values.sms}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.sms && touched.sms
                          ? "input-error input"
                          : "input"
                      }
                    />
                  </label>
                  <label className="label">
                    Whatsapp?
                    <input
                      id="com_whatsapp"
                      name="com_whatsapp"
                      type="checkbox"
                      checked={values.com_whatsapp}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.com_whatsapp && touched.com_whatsapp
                          ? "input-error input"
                          : "input"
                      }
                    />
                  </label>
                  {errors.com_whatsapp && touched.com_whatsapp ? (
                    <p className="error-message">{errors.com_whatsapp}</p>
                  ) : null}
                </div>
              </div>

              <div className="form-input takes1-7">
                <textarea
                  rows="4"
                  cols="50"
                  id="observacao"
                  name="observacao"
                  type="textarea"
                  placeholder="Observações"
                  value={values.observacao}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.observacao && touched.observacao
                      ? "input-error input"
                      : "input"
                  }
                />
                {errors.observacao && touched.observacao ? (
                  <p className="error-message">{errors.observacao}</p>
                ) : null}
              </div>

              <div className="botoes">
                <button
                  className="cancel-btn"
                  onClick={() => navigate(`../../../clientes/${clienteId}`)}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="blue-button"
                  onClick={handleSubmit}
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Edit;
